































import Customer from '@/models/Customer';
import {deleteCustomerDocumentPrescriber, getCustomerDocumentPrescriber, getCustomerDocumentPrescriberById, postCustomerDocumentPrescriber} from '@/api/api';
import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import UploadComponent, {
    InputFile,
} from '@/components/common/UploadComponent.vue';
import get from 'lodash/get';
import { saveAs } from 'file-saver';

interface Loaders {
    [index: string]: boolean;
}

interface Files {
    [index: string]: InputFile | null;
}

@Component({
    components: {
        UploadComponent,
    }
})


export default class ProspectDocs extends Vue {
    isLoading: Boolean = false;
    @Prop() customer!: Customer;
    file: InputFile|null = null;

    customerDocs: any = [];

    filename: string = '';
    docsPopUp: Boolean = false;

    async created() {
        console.log('ok')
        if (!this.customer || !this.customer.id) {
            return;
        }
        const { data } = await getCustomerDocumentPrescriber(this.customer.id);
        this.customerDocs = data;
    }

    async download(doc: any) {
        if (!this.customer || !this.customer.id || !doc || !doc.id) {
            return;
        }
        getCustomerDocumentPrescriberById(this.customer.id, doc.id)
            .then((resp: any) => {
                const fileName = resp.headers['content-disposition'].split(
                    '"'
                )[1];
                try {
                    saveAs(resp.data, doc.name + '.' + doc.extension);
                } catch (e) {
                    console.log('error', e);
                }
            })
            .catch(() => {
                this.showError('Téléchargement impossible')
            });
        
    }

    async deleteDoc(doc: any) {
        if (!this.customer || !this.customer.id || !doc || !doc.id) {
            return;
        }
        const { data } = await deleteCustomerDocumentPrescriber(this.customer.id, doc.id);
        let index = this.customerDocs.indexOf(doc)
        if (index > -1) {
            this.customerDocs.splice(index, 1); // 2nd parameter means remove one item only
        }
        this.showSuccess('Document supprimé')
    }

    onDelete() {
        this.file = null;
    }

    async onFile(file: InputFile) {
        if (!this.customer || !this.customer.id) {
            return;
        }

        try {
            this.isLoading = true;
            // @ts-ignore
            this.file.filename = file.filename;
            // @ts-ignore
            this.file.data = file.data;

            //this.$emit('customer', data);
            this.showSuccess('Fichier pré-enregistré');
        } catch {
            this.showError(`Erreur lors de l'envoi, attention le poids MAX est de 5MB`);
        } finally {
            this.isLoading = false;
        }
    }

    async postFile() {
        if(!this.file || !this.customer || !this.customer.id) {
            return;
        }
        const { data } = await postCustomerDocumentPrescriber(
            this.customer.id,
            {
                // @ts-ignore
                file_name_edited: this.filename,
                file_name: this.file.filename,
                document: this.file.data,
            }
        );

        this.customerDocs.push(data);
        this.showSuccess('Document Enregistré')
        this.file = null;
        this.filename = '';
    }

    showSuccess(message: string) {
        const $vs = (this as any).$vs;
        $vs.notify({
            color: 'success',
            position: 'top-right',
            title: 'Succès',
            text: message,
        });
    }

    showError(defaultMessage: string) {
        const $vs = (this as any).$vs;
        $vs.notify({
            color: 'danger',
            position: 'top-right',
            title: 'Erreur',
            text: defaultMessage,
        });
    }
    
}
